export const queryKeys = {
  authQueryKeys: {
    login: ["login"],
    userDetail: ["USER_PROFILE"],
    forgotPassword: ["FORGOT_PASSWORD"],
    resendOtp: ["RESEND_OTP"],
    verifyOtp: ["VERIFY_OTP"],
    resetPassword: ["RESET_PASSWORD"],
  },
  changePassword: ["CHANGE_PASSWORD"],
  dashboard: {
    stats: "DASHBOARD_STATS",
    revenueGraph: "DASHBOARD_REVENUE_GRAPH",
    userActivityGraph: "DASHBOARD_USER_ACTIVITY_GRAPH",
  },
  userManagement: {
    listing: "USER_LISTING",
    delete: "USER_DELETE",
    statusUpdate: "UPDATE_STATUS",
    details: "USER_DETAILS",
    stats: "USER_STATS",
    profile: "USER_PROFILE",
  },
  bookingsManagement: {
    listing: "BOOKING_LISTING",
    delete: "BOOKING_DELETE",
    details: "BOOKING_DETAILS",
    stats: "BOOKING_STATS",
    categories: "CATEGORIES",
    cities: "CITIES",
    allUsers: "ALL_USERS",
    reviewsListings: "REVIEWS_LISTINGS",
    transactionListing: "TRANSACTION_LISTING",
  },
  disputesManagement: {
    listing: "DISPUTE_LISTING",
    delete: "DISPUTE_DELETE",
    details: "DISPUTE_DETAILS",
    stats: "DISPUTE_STATS",
    chat: "DISPUTE_CHAT",
    resolutionSummary: "RESOLUTION_SUMMARY",
  },

  paymentsManagement: {
    listing: "PAYMENT_LISTING",
    delete: "PAYMENT_DELETE",
    details: "PAYMENT_DETAILS",
    stats: "PAYMENT_STATS",
    transactionHistory: "TRANSACTION_HISTORY",
  },
  reviewsManagement: {
    listing: "REVIEW_LISTING",
    delete: "REVIEW_DELETE",
    details: "REVIEW_DETAILS",
    stats: "REVIEW_STATS",
  },
  lookups: {
    allUsers: "ALL_USERS",
    categories: "CATEGORIES",
    cities: "CITIES",
  },
  verificationManagement: {
    listing: "verificationManagement.listing",
    details: "verificationManagement.details",
    stats: "verificationManagement.stats",
  },
  productRequestsManagement: {
    listing: "productRequestsManagement.listing",
    details: "productRequestsManagement.details",
  },
};
